<template>
  <div>
    <van-nav-bar left-text="返回" left-arrow @click-left="onClickLeft" />
    <div class="service_layout_style">
      <img
        src="../assets/img/客服.jpg"
        alt=""
        style="width: 100%; height: 100%"
      />
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

export default {
  computed: {
    ...mapState(["cgmUserVO"]),
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    onClickLeft() {
      this.$router.push({
        path: "/menu",
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.service_layout_style {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>